const ROUTES = {
  COMPLETE: ":registrationKey",
  DECLINE: "decline/:registrationKey"
};

export default ROUTES;